import {Component, OnInit, ViewChild} from '@angular/core';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {ReferentialService} from '../../../../../shared/services/referential/referential.service';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-unit-key-modal',
  templateUrl: './unit-key-modal.component.html',
  styleUrls: ['./unit-key-modal.component.css']
})
export class UnitKeyModalComponent implements OnInit {
  faTimes = faTimes;
  public unitsList: any;
  public units: any;
  public displayedColumns: string[] = ['value', 'unit'];
  public pageSizeOptions = environment.pageSizeOptions;
  public pageSize = environment.pageSize;
  public isLoading = true;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;

  constructor(private referentialService: ReferentialService) {
  }

  ngOnInit() {
      this.referentialService.getUnits().subscribe(
        (data) => {
          this.unitsList = data;
          this.isLoading = false;
          this.dataSource = new MatTableDataSource(this.unitsList);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
      );
  }
}
